<template>

  <q-drawer
      ref="drawer"
      v-model="drawerMainModel"
      :breakpoint="400"
      :width="$q.screen.gt.md ? 400 : 300"
      behavior="mobile"
      bordered
      class="c-drawer"
      content-class="bg-white"
      no-swipe-open
      overlay
      side="right"
  >
    <div class="column fit no-wrap">
      <div
          class="q-px-sm q-py-sm flex col-shrink items-center"
      >
        <div class="q-ml-auto">
          <q-btn
              dense
              flat
              size="15px"
              :icon="ICONS.close"
              @click="drawerMainModel = false"
          />
        </div>
      </div>
      <div class="col-grow">

        <q-scroll-area class="fit">
          <q-list separator class="s-font-md">

            <q-item
                clickable
                v-ripple
                exact
                to="/personal/dashboard"
                class="q-py-md"
                v-if="isAuthorized"
                @click="drawerMainModel = false"
            >
              <q-item-section avatar style="min-width: auto;">
                <q-icon :name="ICONS.profileCircle"/>
              </q-item-section>
              <q-item-section>Профиль</q-item-section>
            </q-item>

            <q-item
                clickable
                v-ripple
                exact
                to="/personal/orders/active"
                class="q-py-md"
                v-if="ordersActive.length"
                @click="drawerMainModel = false"
            >
              <q-item-section avatar style="min-width: auto;">
                <q-icon
                    :name="ICONS.orders"
                />
              </q-item-section>
              <q-item-section>
                <div>
                  <div class="relative-position inline-block">
                    {{ ordersActive.length > 1 ? 'Активные заказы' : 'Активный заказ' }}
                    <q-badge class="c-badge" style="position: absolute; top: -3px; right: -20px;">
                      {{ ordersActive.length }}
                    </q-badge>
                  </div>
                </div>
              </q-item-section>
            </q-item>

            <q-item
                v-if="menuItems.top"
                clickable
                v-ripple
                v-for="item in menuItems.top"
                class="q-py-md"
                v-bind="menuItemToListItem(item)"
                @click="drawerMainModel = false"
            >
              <q-item-section avatar style="min-width: auto;" v-if="item.icon">
                <q-icon :name="resolveIcon(item.icon)"/>
              </q-item-section>
              <q-item-section>{{ item.label }}</q-item-section>
            </q-item>

          </q-list>
        </q-scroll-area>
      </div>

    </div>

  </q-drawer>
</template>
<script setup lang="ts">

import {ICONS, resolveIcon} from "@/assets/icons";
import {useLayoutStore} from "@/stores/layout";
import {useMenuStore} from "@/modules/menu/store/menu";
import {useOrdersStore} from "@/modules/shop/store/orders";
import {storeToRefs} from "pinia";
import {menuItemToListItem} from "@/core/util/project/menuItemToListItem";
import {useQuasar} from "quasar";
import {useUserStore} from "@/modules/user/store/user";

const userStore = useUserStore()
const menuStore = useMenuStore()
const layoutStore = useLayoutStore()
const ordersStore = useOrdersStore()

const {menuItems} = storeToRefs(menuStore)
const {drawerMainModel} = storeToRefs(layoutStore)
const {ordersActive} = storeToRefs(ordersStore)
const {isAuthorized} = storeToRefs(userStore)

const $q = useQuasar();

</script>

<style lang="scss" scoped>

.q-item {
  font-weight: 500;
  border-top: 1px solid #f2f2f2 !important;
}


</style>


